import React, { useState, useEffect, useContext, useRef } from 'react'
import Container from '@material-ui/core/Container'
import DashboardHeader from '../DashboardHeader'
import Layout from '../Layout'
import AllProducts from '../../../Component/MyBids/AllProducts'
import StripeCustomerContext from '../../../Product/context/stripe/customer/customerContext'
import AuthContext from '../../../Product/context/auth/authContext'
import buyerContext from '../../../Product/context/buyer/buyerContext'
import axios from 'axios'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const ScheduledPickup = (props) => {
    const { buyer_allproducts } = useContext(buyerContext)
    const cancelToken = axios.CancelToken.source()
    const [cancelRequest, setCancelRequest] = useState(undefined)
    const authContext = useContext(AuthContext)
    const { user, loadUser } = authContext
    const {
        createStripeCustomer,
        addCustomerProfile,
        responseStatus: responseStatusStripeCustomer,
    } = useContext(StripeCustomerContext)
    const buyerAllProductsRef = useRef(buyer_allproducts)
    useEffect(() => {
        buyerAllProductsRef.current = buyer_allproducts
    })
    useEffect(() => {
        if (
            user &&
            !user.card_paymentid &&
            global.storeConfigration?.credit_card_no_need?.value == 1 &&
            global.storeConfigration?.stripe_integration?.value !== '1' &&
            global.storeConfigration?.enable_cardknox !== '1'
        ) {
            createStripeCustomer({
                account_id: process.env.REACT_APP_AUCTIONPAYID,
                description: 'CREATE CUSTOMER',
                email: user.email,
                name: user.first_name + ' ' + user.last_name,
            })
        }
    }, [user])

    useEffect(() => {
        if (
            responseStatusStripeCustomer &&
            global.storeConfigration?.credit_card_no_need?.value == 1 &&
            global.storeConfigration?.enable_cardknox !== '1'
        ) {
            if (responseStatusStripeCustomer.status === 'success') {
                if (responseStatusStripeCustomer.from === 'create') {
                    addCustomerProfile({
                        customer_id: responseStatusStripeCustomer.data.id,
                    })
                }
                loadUser()
            }
        }
    }, [responseStatusStripeCustomer])

    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'

    return (
        <>
            <SEOTAG page="Scheduled Pickup" />
            <Layout props={props}>
                <div className="GFdashWrapperContainer">
                    <DashboardHeader />
                    <Container className="db-bids-wrapper loa-bids">
                        <AllProducts
                            page="bidwon"
                            currency={props.currency}
                            sliderTheme={props.sliderTheme}
                            shippingauction={props.shippingauction}
                            storeTheme={'Lotsofauctions'}
                            checkout_but_pos={props.checkout_but_pos}
                            schedule={true}
                            redirect_product_view={props.redirect_product_view}
                            pickupCode={props.pickupCode}
                            searchbar={true}
                            cancelRequest={cancelRequest}
                            cancelToken={cancelToken}
                            setCancelRequest={setCancelRequest}
                            sch_type={2}
                            hideReturn={true}
                            isGFDashMenuList={true}
                            sch_status={'ready'}
                            need_buynow={true}
                            from_page={'readyForPickup'}
                        />
                    </Container>
                </div>
            </Layout>
        </>
    )
}

export default ScheduledPickup
